﻿import { useState } from "react";
import RichTextEditor, { EditorValue } from "react-rte";
import { ParticipantModel, uriGid } from "./participantInfo";

//import * as Appdata from '../customappsettings.json';
export interface IntInfo {
    isSuccess: boolean;
    message: string;
    data: any;
    statusCode: string;
    jwtToken: any;
    //totalCount: any;
    errorLog: any;
}
let data2: IntInfo;
let varRemarks: string;
varRemarks = "";

export interface RemarkList {
    ratingID: number
    remark: string
}[]

export async function postinterviewcomplete(code: string | null) {
    const getData =
        await fetch(window.rAPI + "v1/Interview/Complete", {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "code": code,
                "exitState": 0
            })
        }).then(function (response) {
           // console.log(response)
            return response.json();
        }).then(function (myJson) {
           // console.log(myJson);

            data2 = myJson as IntInfo;
          //  console.log(data2.message);

        });

   // await getData;
    //console.log("postinterviewcomplete api called");
    //return data2;
}

export async function SaveRatings(code: string | null,ratingId:number,txtId:string) {

    var listRatings = [];
    var inputs = document.getElementById(txtId) as HTMLInputElement;
    //console.log("inputs");
    //console.log(inputs);
    //for (var i = 0; i < inputs.length; i++) {
       
    var rateScore = parseFloat(inputs.value);
    rateScore = isNaN(rateScore) ? 1 : rateScore;
    //console.log("rateScore");
    //console.log(rateScore);

    if (rateScore > 0) {
        listRatings.push({
            id: ratingId,
            score: rateScore
        });

        //}

        console.log("listRatings");
        console.log(listRatings);

        const getData =
            await fetch(window.answerAPI + "v1/Ratings/Add", {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    "code": code,
                    "listRatings": listRatings
                })
            }).then(function (response) {
                // console.log(response)
                return response.json();
            });

        await getData;
    }
    //console.log("postinterviewcomplete api called");
    //return data2;
}

export async function SaveRemarks(code: string | null, txtRemarks: string, remarks: RemarkList[]) {

    
    varRemarks = txtRemarks;
    const getData =
        await fetch(answerAPI + "v1/Notes/Add", {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "code": code,
                "note": txtRemarks,
                "remarks": remarks
            })
        }).then(function (response) {
            let btnCss = document.getElementById("btnSaveRemark") as HTMLButtonElement;

            if (btnCss)
            btnCss.style.backgroundColor = 'rgb(12, 68, 172)';
        });

   
    
    //console.log("postinterviewcomplete api called");
    //return data2;
}


export async function UpdateCandidateStatus(code: string | null,statusId:number) {
    const userData = ParticipantModel();
    const message = "##UserRole# has marked the interview as a ##ActionStatus#.";
    const getData =
        await fetch(window.rAPI + "v1/Interview/CandidateStatus/Update", {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "code": code,
                "statusId": statusId,
                "assessmentType": 4,
                "groupId": uriGid,
                "firstName": userData.userName,
                "logActivityInfo": { eventType: "Ratings", message: message }
            })
        }).then(function (response) {
            // console.log(response)
            return response.json();
        }).then(function (myJson) {
            // console.log(myJson);

            data2 = myJson as IntInfo;
            //  console.log(data2.message);

        });

    await getData;
    //console.log("postinterviewcomplete api called");
    //return data2;
}

let showBanner = 0;
showBanner = 0;

export function ShowHideEndCallBanner() {
    showBanner = showBanner + 1;
    return showBanner;
}


export async function SaveMultipleRatings(code: string | null) {

    var listRatings = [];
    var inputs = document.querySelectorAll("[id^=ratingTxt_]");

    for (var i = 0; i < inputs.length; i++) {
        var rateId = parseInt(inputs[i].id.replace("ratingTxt_", ""));
        var rateScore = (inputs[i] as HTMLInputElement).value;

        listRatings.push({
            id: rateId,
            score: rateScore
        });

    }

    const getData =
        await fetch(window.answerAPI + "v1/Ratings/Add", {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "code": code,
                listRatings: listRatings
            })
        }).then(function (response) {
            // console.log(response)
            return response.json();
        });

    await getData;
    //console.log("postinterviewcomplete api called");
    //return data2;
}



const intCompleteModel = () => {
        return {
            Umessage: data2.message
        }
};

export { intCompleteModel, varRemarks };

